import React, { useEffect, useRef, useState } from 'react'
import { useTranslation } from 'react-i18next'
import Select from 'react-select'

import { httpOk, GET } from 'helpers/api'

// Селект исполнителей. Своя команда уже подгружена доской и показывается сразу,
// а любого другого активного партнёра находим поиском на сервере — по имени,
// логину или телефону. Так лид можно вести вместе с тем, кто в дереве бонусов
// стоит отдельной веткой.
function PartnerSearchSelect({
	apiPrefix,
	partners = [],
	value = [],
	onChange,
	excludeId = null,
	styles = undefined,
	placeholder = '',
	isDisabled = false,
}) {
	const { t } = useTranslation()

	// null — поиска не было, показываем свою команду
	const [found, setFound] = useState(null)
	const [loading, setLoading] = useState(false)

	const searchTimerRef = useRef(null)

	async function getPartners(search = '') {
		if (!search) {
			setFound(null)
			return
		}

		setLoading(true)
		const url = `${apiPrefix}/helper/task-partners?search=` + encodeURIComponent(search)
		const response = await GET(url, {}, { loader: false })
		if (httpOk(response)) {
			setFound((response.data || []).filter(item => item.id !== excludeId))
		}
		setLoading(false)
	}

	function handleSearch(search, action) {
		// react-select дёргает onInputChange ещё и на blur/menu-close с пустой строкой
		if (action && action.action !== 'input-change') return

		if (searchTimerRef.current) clearTimeout(searchTimerRef.current)
		searchTimerRef.current = setTimeout(() => {
			getPartners(search)
		}, 500)
	}

	// В выбранном значении — только имя, в списке — ещё логин с телефоном,
	// потому что тёзок среди партнёров хватает
	function formatPartnerOption(option, meta) {
		const title = option.name || option.login

		if (meta.context === 'value') {
			return <span>{title}</span>
		}

		return (
			<div className="tasks-select-option">
				<div className="tasks-select-option-title">{title}</div>
				<div className="tasks-select-option-sub">
					<span>{option.login}</span>
					{option.phone && <span>{option.phone}</span>}
				</div>
			</div>
		)
	}

	useEffect(() => {
		return () => {
			if (searchTimerRef.current) clearTimeout(searchTimerRef.current)
		}
	}, [])

	return (
		<Select
			isMulti
			isClearable
			isDisabled={isDisabled}
			isLoading={loading}
			styles={styles}
			options={found === null ? partners : found}
			value={value}
			onChange={(options) => onChange(options || [])}
			onInputChange={(search, action) => handleSearch(search, action)}
			filterOption={() => true}
			placeholder={placeholder}
			noOptionsMessage={() => t('list_empty')}
			formatOptionLabel={(option, meta) => formatPartnerOption(option, meta)}
			getOptionLabel={(option) => (option.name || option.login) + ' · ' + option.login}
			getOptionValue={(option) => option.id}
		/>
	)
}

export default PartnerSearchSelect
